// indexedDbUtils.js
import { openDB } from "idb";

const DB_NAME = "foodOrder";
const STORE_NAME = "foodImages";

// 1. Open DB and create object store if not exists
export async function getDB() {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "id" }); // id = memberId
      }
    },
  });
}

// 2. Store image
export async function saveImageToIndexedDB(memberId, imageBlob, updatedTime) {
  const db = await getDB();
  const tx = db.transaction(STORE_NAME, "readwrite");
  const store = tx.objectStore(STORE_NAME);

  await store.put({
    id: memberId,
    imageBlob,
    updatedTime,
  });

  await tx.done;
}

// 3. Get image and updatedTime
export async function getImageFromIndexedDB(memberId) {
  const db = await getDB();
  const tx = db.transaction(STORE_NAME, "readonly");
  const store = tx.objectStore(STORE_NAME);
  // console.log("inside getImageFromIndexedDB");
  // console.log(await store.get(memberId));
  return await store.get(memberId);
}

// 4. Delete image (optional cleanup)
export async function deleteImageFromIndexedDB(memberId) {
  const db = await getDB();
  const tx = db.transaction(STORE_NAME, "readwrite");
  const store = tx.objectStore(STORE_NAME);
  await store.delete(memberId);
  await tx.done;
}
